import { render } from "./LoginForm.vue?vue&type=template&id=2ca00896&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=2ca00896&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ca00896"

export default script